"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const UI_1 = require("~/components/UI");
const assets_1 = require("~/assets");
const utils_1 = require("~/utils/utils");
const DiscountEditor_module_scss_1 = __importDefault(require("./DiscountEditor.module.scss"));
function DiscountEditor({ discount, isDateOverlaping, onValidStateChange, onDiscountChange, onDiscountDelete, }) {
    const { t } = (0, react_i18next_1.useTranslation)('customer');
    const [extrusionsDiscount, setExtrusionsDiscount] = (0, react_1.useState)(discount.extrusionsDiscount);
    const [componentsDiscount, setComponentsDiscount] = (0, react_1.useState)(discount.componentsDiscount);
    const [machiningDiscount, setMachiningDiscount] = (0, react_1.useState)(discount.machiningDiscount);
    const [startDate, setStartDate] = (0, react_1.useState)({
        value: (0, utils_1.formatDateForDateInput)(discount.startDate),
        error: null,
    });
    const [lastValidStartDate, setLastValidStartDate] = (0, react_1.useState)(startDate.value);
    const [expirationDate, setExpirationDate] = (0, react_1.useState)({
        value: discount.expirationDate ? (0, utils_1.formatDateForDateInput)(discount.expirationDate) : '',
        error: null,
    });
    const [isValid, setIsValid] = (0, react_1.useState)(false);
    const startDatePickerRef = (0, react_1.useRef)(null);
    const expirationDatePickerRef = (0, react_1.useRef)(null);
    const extrusionsDiscountElement = (0, react_1.useRef)(null);
    const componentsDiscountElement = (0, react_1.useRef)(null);
    const machiningDiscountElement = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        onDiscountChange({
            id: discount.id,
            extrusionsDiscount,
            componentsDiscount,
            machiningDiscount,
            startDate: new Date(startDate.value),
            expirationDate: new Date(expirationDate.value),
        });
        const isCurrentStateValid = (extrusionsDiscount > 0 || componentsDiscount > 0 || machiningDiscount > 0) &&
            (!expirationDate.value || new Date(startDate.value) <= new Date(expirationDate.value)) &&
            !startDate.error &&
            !expirationDate.error &&
            !!startDate;
        if (isValid !== isCurrentStateValid) {
            onValidStateChange(discount.id, isCurrentStateValid);
            setIsValid(isCurrentStateValid);
        }
    }, [extrusionsDiscount, componentsDiscount, machiningDiscount, startDate, expirationDate]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        (_a = startDatePickerRef.current) === null || _a === void 0 ? void 0 : _a.showError(null, isDateOverlaping ? t('error.overlaping-date') : undefined);
        (_b = expirationDatePickerRef.current) === null || _b === void 0 ? void 0 : _b.showError(null, isDateOverlaping ? t('error.overlaping-date') : undefined);
    }, [isDateOverlaping, startDate, expirationDate]);
    const onExpirationDateChange = (value, error) => {
        var _a;
        setExpirationDate({ value, error });
        if (expirationDate.value && new Date(startDate.value) > new Date(value)) {
            setStartDate({ value, error });
            (_a = startDatePickerRef.current) === null || _a === void 0 ? void 0 : _a.setValue(value);
        }
    };
    const onStartDateChange = (value, error) => {
        var _a, _b;
        if (!value) {
            setStartDate({ value: lastValidStartDate, error: startDate.error });
            (_a = startDatePickerRef.current) === null || _a === void 0 ? void 0 : _a.setValue(lastValidStartDate);
        }
        else {
            setLastValidStartDate(value);
            setStartDate({ value, error });
            if (expirationDate.value && new Date(value) > new Date(expirationDate.value)) {
                setExpirationDate({ value, error });
                (_b = expirationDatePickerRef.current) === null || _b === void 0 ? void 0 : _b.setValue(value);
            }
        }
    };
    const onDelete = () => {
        onDiscountDelete(discount.id);
    };
    const onBlurNumber = (setter, elementRef) => {
        return (value, error) => {
            var _a;
            if (!value) {
                setter(0);
                (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.setValue('0');
            }
        };
    };
    const passNumberToSetter = (setter) => {
        return (value, error) => {
            setter(Number(value));
        };
    };
    return (react_1.default.createElement("div", { className: DiscountEditor_module_scss_1.default.content },
        react_1.default.createElement("form", null,
            react_1.default.createElement("div", { className: DiscountEditor_module_scss_1.default.row },
                react_1.default.createElement("div", { className: DiscountEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement("label", null, t('information.extrusion-discount')),
                    react_1.default.createElement(UI_1.Input, { type: "number", value: extrusionsDiscount, onChange: passNumberToSetter(setExtrusionsDiscount), onInput: passNumberToSetter(setExtrusionsDiscount), onBlur: onBlurNumber(setExtrusionsDiscount, extrusionsDiscountElement), ref: extrusionsDiscountElement, maxLength: 2, min: 0, max: 99 })),
                react_1.default.createElement("div", { className: DiscountEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement("label", null, t('information.component-discount')),
                    react_1.default.createElement(UI_1.Input, { type: "number", value: componentsDiscount, onChange: passNumberToSetter(setComponentsDiscount), onInput: passNumberToSetter(setComponentsDiscount), onBlur: onBlurNumber(setComponentsDiscount, componentsDiscountElement), ref: componentsDiscountElement, maxLength: 2, min: 0, max: 99 })),
                react_1.default.createElement("div", { className: DiscountEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement("label", null, t('information.machining-discount')),
                    react_1.default.createElement(UI_1.Input, { type: "number", value: machiningDiscount, onChange: passNumberToSetter(setMachiningDiscount), onInput: passNumberToSetter(setMachiningDiscount), onBlur: onBlurNumber(setMachiningDiscount, machiningDiscountElement), ref: machiningDiscountElement, maxLength: 2, min: 0, max: 99 })),
                react_1.default.createElement("div", { className: DiscountEditor_module_scss_1.default['element_centered-content'] },
                    react_1.default.createElement("img", { onClick: onDelete, onKeyDown: (e) => e.key === 'Enter' && onDelete(), src: assets_1.svgBasicTrashIcon, alt: "delete", className: DiscountEditor_module_scss_1.default.image, tabIndex: 0, role: "button" }))),
            react_1.default.createElement("div", { className: DiscountEditor_module_scss_1.default.row },
                react_1.default.createElement("div", { className: DiscountEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement("label", null, t('information.start-date')),
                    react_1.default.createElement(UI_1.Input, { type: "date", value: startDate.value, onChange: (value, error) => setStartDate({ value, error }), onInput: (value, error) => setStartDate({ value, error }), onBlur: onStartDateChange, hideErrorOnFocus: false, ref: startDatePickerRef })),
                react_1.default.createElement("div", { className: DiscountEditor_module_scss_1.default.element_growing },
                    react_1.default.createElement("label", null, t('information.expiration-date')),
                    react_1.default.createElement(UI_1.Input, { type: "date", value: expirationDate.value, onChange: (value, error) => setExpirationDate({ value, error }), onInput: (value, error) => setExpirationDate({ value, error }), onBlur: onExpirationDateChange, hideErrorOnFocus: false, ref: expirationDatePickerRef }))))));
}
exports.default = DiscountEditor;
